/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     Documents
//   Details:    Documents page
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// WI3713 24/01/24 JC  M01JC	Extended for data forms
//-------------------------------------------------------
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import ItemsPage from '../components/ItemsPage';
import { itemCategories } from '../constants/ItemCategories';

class Documents extends Component {

	render() {
		return (
			<ItemsPage
				title="Documents"

				unreadTabText="Unread"
				readTabText="Read"

				unread={this.props.unread}
				read={this.props.read}

				unreadItemTypes={this.props.unreadItemTypes}
				readItemTypes={this.props.readItemTypes}

				unreadItemCategory={this.props.unreadItemCategory}
				readItemCategory={this.props.readItemCategory}

				match={this.props.match}//M03JC
				redirectController={this.props.redirectController}//M03JC
			/>
		);
	}
}

export default connect(
	state => ({
		unread: state.unreadDocuments,
		read: state.readDocuments,

		unreadItemTypes: state.unreadDocumentTypes,
		readItemTypes: state.readDocumentTypes,

		unreadItemCategory: itemCategories.unreadDocuments,
		readItemCategory: itemCategories.readDocuments,

		redirectController: state.redirectController //M01JC
	})
)(Documents);